export default "__VITE_ASSET__DpuG61Xy__"